import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface PrescriptionListParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}
export interface PrescriptionList {
 id: number ;
 brancH_TYPE:any;
 brancH_ID:any;
 pharmacY_ID: number ;
 medicinE_ID:any;
 batch:any;
 exp_date:any;
 units_strips: number ;
 sell_mrp:any;
 cp:any;
 mrp:any;
 igst_per:any;
 cgst_per:any;
 sgst_per:any;
 gst_total_per:any;
 pur: number ;
 puR_RTN: number ;
 sal: number ;
 saL_RTN: number ;
 stK_PLUS: number ;
 stK_MINUS: number ;
 stK_OPEN: number ;
 stock_In: number ;
 stock_Out: number ;
 balance: number ;
}


export abstract class PrescriptionListData {
  abstract getById(url: string): Observable<any>;
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string, data: any): Observable<any>;
  abstract update(url: string, data: PrescriptionList): Observable<PrescriptionList>;
  abstract delete(url: string): Observable<any>;
}

